import type { Endpoint } from ".";

export const getAsset: Endpoint = {
  id: "getAsset",
  method: "GET",
  path: "/projects/{project_id}/properties/{property_id}/assets/{asset_id}",
  summary: "Get asset",
  description: "Returns a single asset row.",
  params: [
    {
      name: "project_id",
      in: "path",
      required: true,
      description: "UUID of the project.",
      type: "uuid",
      defaultFromClientId: true,
    },
    {
      name: "property_id",
      in: "path",
      required: true,
      description: "UUID of the property.",
      type: "uuid",
    },
    {
      name: "asset_id",
      in: "path",
      required: true,
      description: "UUID of the asset.",
      type: "uuid",
    },
  ],
};
